import React from 'react';
import Loader from 'react-loader-spinner';
import generateLoaderType from 'helpers/generateLoaderType';

const loaderType = generateLoaderType();

const Spinner = ({
  showLoader = false,
  type,
  color,
  height,
  width,
  timeout,
  styles,
}) => {
  if (!showLoader) return null;

  const spinnerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 10,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255,0.8)',
    ...styles,
  };

  return (
    <div style={spinnerStyle}>
      <Loader
        type={type || loaderType}
        color={color || '#206bef'}
        height={height || 100}
        width={width || 100}
        timeout={timeout || 2500}
      />
    </div>
  );
};

export default Spinner;
